<template>
  <div v-loading="Loading">
    <!-- 添加用户 -->
    <div>
      <el-input
        v-model="conditionMember.keyword"
        style="width: 600px; margin-bottom: 20px"
        placeholder="昵称、用户名、手机号、邮箱号"
        @keyup.enter.native="search(true)"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="search(true)"
        ></el-button>
      </el-input>
    </div>
    <!-- <el-table :data="memberData" ref="multipleTable"
       @selection-change="userSelectChange" style="margin-bottom:10px;"> -->
    <el-table
      ref="multipleTable"
      :data="memberData"
      style="width: 100%; min-height: 300px"
      header-row-class-name="table-header"
      tooltip-effect="dark"
      @select="onTableSelect"
      @select-all="onTableSelectAll"
      @selection-change="handleSelectionChange"
      :row-key="getRowKey"
    >
      <!-- <el-table-column type="selection" :reserve-selection="true" width="55">
      </el-table-column> -->
      <!-- <el-table-column type="selection" width="55"></el-table-column> -->
      <el-table-column
        property="userName"
        label="用户名"
        width="150"
      ></el-table-column>
      <el-table-column
        property="realName"
        label="真实姓名"
        width="200"
      ></el-table-column>
      <el-table-column property="phoneNumber" label="手机号"></el-table-column>
      <el-table-column property="email" label="邮箱号"></el-table-column>
      <el-table-column label="操作" header-align="center" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="save(scope.row)"
            >选择</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 30px; text-align: center"
      :page-size="conditionMember.pageSize"
      :current-page.sync="conditionMember.pageIndex"
      @size-change="handleSizeChange"
      @current-change="search(false)"
    ></el-pagination>
  </div>
</template>
<script>
export default {
  data() {
    return {
      Loading: false,
      memberData: [], // 用户列表数据
      multipleSelection: [], // 选中列表数据
      multipleleng: [],
      total: 0,
      conditionMember: {
        pageIndex: 1,
        showItem: 10,
        keyword: "",
      },
    };
  },
  components: {},

  methods: {
    initView() {
      this.memberData = []; // 用户列表数据
      this.multipleSelection = []; // 选中列表数据
      this.conditionMember = {
        pageIndex: 1,
        showItem: 10,
        keyword: "",
      };
    },
    // 选择框
    handleSelectionChange(val) {
      let value = [];
      value = [...val];
      this.multipleleng = value;
    },
    onTableSelect(val, row) {
      if (this.multipleSelection.length < val.length) {
        // 选中
        this.multipleSelection.push(row);
      } else {
        // 未选中
        let data = this.multipleSelection.filter(
          (item) => item.userId != row.userId
        );
        this.multipleSelection = [...data];
      }
    },
    getRowKey(row) {
      return row.userId;
    },
    handleSizeChange(val) {
      this.conditionMember.pageIndex = 1;
      this.conditionMember.showItem = val;
      this.search();
    },
    onTableSelectAll(Selection) {
      let than = this;
      if (Selection.length > 0) {
        // 选中
        Selection.forEach((item, i) => {
          if (
            this.multipleSelection.filter((lis) => lis.userId == item.userId)
              .length == 0
          ) {
            than.multipleSelection.push(item);
          }
        });
      } else {
        // 未选中
        than.memberData.forEach((row, i) => {
          let data = this.multipleSelection.filter(
            (item) => item.userId != row.userId
          );
          this.multipleSelection = [...data];
        });
      }
    },
    // 多选用户
    userSelectChange(val) {
      this.multipleSelection = val;
    },

    search(type) {
      if (type) {
        this.conditionMember.pageIndex = 1;
      }
      this.Loading = true;
      this.$api.user.userList(this.conditionMember).then((data) => {
        if (data.errCode == 0) {
          this.Loading = false;
          this.memberData = data.data.items;
          this.total = data.data.totalItems;
        } else {
          this.$message.error(data.errMsg);
        }
      });
    },
    save(row) {
      this.$emit("getConsultant", { ...row });
    },
  },
  created() {
    this.search(true);
  },
};
</script>
<style lang="less">
</style>